var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"specialTopic"}},[_c('div',{staticClass:"banner"},[_c('div',{staticClass:"bannerImg",class:'bannerImg'+_vm.viewId})]),_vm._v(" "),_c(_vm.Comname,{tag:"component",attrs:{"visible":_vm.show,"viewId":_vm.viewId},on:{"update:visible":function($event){_vm.show=$event}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c5bb354","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/view/app_specialTopic/index.vue
// module id = null
// module chunks = 